var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"cosmobanner"}},[_c('v-img',{attrs:{"height":"750","src":_vm.getImageUrlbyName('CosmoBanner')}},[_c('div',{attrs:{"id":"cosmocontent"}},[_c('v-icon',{attrs:{"size":"140","id":"as","color":"pink"}},[_vm._v("mdi-format-quote-close")]),_c('div',{attrs:{"id":"cosmotext"}},[_vm._v(_vm._s(_vm.$t("message.CosmoText")))])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }